const styles = theme => ({
  root: {
    marginTop: 10,
    padding: 5,
    width: "calc(100% / 2)"
  },

  container: {
    border: "1px solid #ccc",
    borderRadius: 10,
    boxShadow: "0 0 10px rgba(0, 0, 0, .2)",
    display: 'flex',
    flexWrap: 'wrap',
  },

  image: {
    '& img': {
      height: 100,
      width: 100,
      padding: 10,
      display: 'block',
      margin: 'auto',
      borderRadius: 15
    }
  },

  content: {
    padding: 5,
    width: "calc(100% - 110px)",
    '& h4': {
      overflow: 'hidden',
      color: theme.colors.primary,
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical'
    },
    '& p': {
      overflow: 'hidden',
      color: '#4d4d4d',
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical'
    }
  },

  [theme.breakpoints.down('xs')]: {
    root: {
      width: "100%"
    },
  }
});

export default styles;